__turbopack_context__.v({
  "component": "style-module-scss-module__Vqtsza__component",
  "loading-spinner": "style-module-scss-module__Vqtsza__loading-spinner",
  "view-more": "style-module-scss-module__Vqtsza__view-more",
});
